import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { refreshTokenUser, selectHasPermission } from "../redux/features/auth/authSlice";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default function ProtectedRoute({ children, requiredPermission }) {
  const dispatch = useDispatch();
  const { isAuthenticated, refreshTokenLoading } = useSelector(
    (state) => state.auth
  );
  
  const hasPermission = useSelector((state) => 
    requiredPermission ? selectHasPermission(state, requiredPermission) : true
  );

  const token = localStorage.getItem("OrviSlideToken");

  useEffect(() => {
    if (!isAuthenticated && token) {
      dispatch(refreshTokenUser());
    }
  }, [isAuthenticated, dispatch, token]);

  if (refreshTokenLoading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 text-gray-700 z-50 transition-opacity duration-300">
        <FontAwesomeIcon
          icon={faSpinner}
          className="animate-spin text-purpleColor text-6xl mb-4"
        />
        <p className="text-2xl font-medium text-gray-500 animate-pulse">
          Loading....
        </p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission && !hasPermission) {
    return <Navigate to="/" replace />;
  }

  return children;
}
